import { render, staticRenderFns } from "./the-legacy-bullhorn-data-container.vue?vue&type=template&id=64c1fb5b"
import script from "./the-legacy-bullhorn-data-container.vue?vue&type=script&lang=js"
export * from "./the-legacy-bullhorn-data-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports